<template>
	<Chart
		ref="ref__chart"
		:options="chartOptions"
		class="w-full h-fit"
	/>
</template>

<script>
import Highcharts from 'highcharts'
import { Chart } from 'highcharts-vue'
import i18n from '../../../../VueI18n'

export default {
	name: 'GraficoBalancoHidrico',
	components: {
		Chart,
	},
	props: {
		/**
		 * Resposta do endpoint /BalancoHidrico/serie-mensal da Climate API:
		 * { cadMm, meses: [{ ano, mes, precipitacao, etp, etr, deficit,
		 *   excedente, armazenamentoMedio }] }
		 */
		data: { type: Object, required: true },
		/**
		 * Séries biométricas por estrato no formato do Highcharts
		 * ({ name, color, data: [[timestamp, valor]] }), plotadas no eixo
		 * da direita para visualizar a influência do clima na variável.
		 */
		seriesBiometricas: { type: Array, default: () => [] },
		/**
		 * Rótulo do eixo da variável biométrica selecionada (ex.: VTCC).
		 */
		tituloVariavel: { type: String, default: '' },
	},
	computed: {
		chartOptions() {
			//Timestamp do dia 15 de cada mês, para o ponto mensal cair no meio do mês
			const pontoMensal = (m) => Date.UTC(m.ano, m.mes - 1, 15)
			const meses = this.data.meses

			return {
				credits: { enabled: false },
				exporting: { enabled: false },
				chart: { height: 340, zoomType: 'x' },
				title: { text: '' },
				subtitle: {
					text: `CAD ${this.data.cadMm} mm · NASA POWER + Embrapa Solos`,
					align: 'left',
				},
				legend: { enabled: true },
				xAxis: {
					type: 'datetime',
					crosshair: true,
					labels: {
						formatter: function () {
							return Highcharts.dateFormat('%m/%Y', this.value)
						},
					},
				},
				yAxis: [
					{
						title: { text: 'mm' },
						min: 0,
						plotLines: [
							{
								value: this.data.cadMm,
								color: '#8A97A8',
								dashStyle: 'Dash',
								width: 2,
								zIndex: 4,
								label: {
									text: `CAD ${this.data.cadMm} mm`,
									style: { color: '#8A97A8', fontSize: '10px' },
								},
							},
						],
					},
					{
						title: { text: this.tituloVariavel },
						opposite: true,
					},
				],
				tooltip: {
					shared: true,
					xDateFormat: '%m/%Y',
				},
				plotOptions: {
					column: { borderRadius: 2, pointPadding: 0, groupPadding: 0.05 },
					areaspline: { fillOpacity: 0.25, marker: { enabled: false } },
					spline: { marker: { enabled: false } },
				},
				series: [
					{
						type: 'areaspline',
						name: i18n.t('soilWaterStorage'),
						data: meses.map((m) => [pontoMensal(m), m.armazenamentoMedio]),
						color: '#93A39C',
						tooltip: { valueSuffix: ' mm' },
						zIndex: 1,
					},
					{
						type: 'column',
						name: i18n.t('precipitation'),
						data: meses.map((m) => [pontoMensal(m), m.precipitacao]),
						color: '#2A78D6',
						tooltip: { valueSuffix: ' mm' },
						zIndex: 2,
					},
					{
						type: 'spline',
						name: 'ETp',
						data: meses.map((m) => [pontoMensal(m), m.etp]),
						color: '#EB6834',
						tooltip: { valueSuffix: ' mm' },
						visible: false,
						zIndex: 3,
					},
					{
						type: 'spline',
						name: 'ETR',
						data: meses.map((m) => [pontoMensal(m), m.etr]),
						color: '#1BAF7A',
						tooltip: { valueSuffix: ' mm' },
						visible: false,
						zIndex: 3,
					},
					{
						type: 'spline',
						name: `${i18n.t('waterDeficit')} (DEF)`,
						data: meses.map((m) => [pontoMensal(m), m.deficit]),
						color: '#E34948',
						tooltip: { valueSuffix: ' mm' },
						visible: false,
						zIndex: 3,
					},
					//Variáveis biométricas por estrato, no eixo da direita: pontos
					//esparsos (datas de medição) ligados por linha
					...this.seriesBiometricas.map((serie) => ({
						type: 'spline',
						yAxis: 1,
						name: serie.name,
						color: serie.color,
						data: serie.data,
						marker: { enabled: true, radius: 4 },
						zIndex: 5,
					})),
				],
			}
		},
	},
}
</script>
